module.exports = __webpack_public_path__ + "static/n5consulting-d5085bfd66cbf1f59beb8c3636d7a431.mp4";